export default function HistoricalAlertsViewNewNotesController($scope, $rootScope, $uibModalInstance, alert, alertsRepository, gettextCatalog) {

  'ngInject';

  $scope.alert = alert;
  $scope.errorFlag = false;
  $scope.errorText = '';

  //variable use to refresh the history detail page
  $scope.creatingnote = false;
  var userEmail = '';

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.$on('$locationChangeStart', function (event, next, current) {
    $scope.cancel();
    event.preventDefault();
  });

  $scope.createNewNote = function (noteText) {
    $scope.creatingnote = true;
    $scope.errorFlag = false;
    var note = {};
    userEmail = $rootScope.currentUser.email;

    note['instanceId'] = alert.instanceId;
    note['text'] = noteText;
    note['enteredBy'] = userEmail;
    note['updatedBy'] = userEmail;

    alertsRepository.createNote(note.instanceId, note).then(function (response) {
      $scope.newNote.text = '';
      $uibModalInstance.close(response.data);
    }, handleError);

  };

  //general error handler.
  function handleError(response) {
    var errorMsg = gettextCatalog.getString('An error occurred while creating the note');
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
      } else {
        errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
      }
    } else {
      errorMsg += gettextCatalog.getString('. Please try again later.');
    }
    $scope.errorFlag = true;
    $scope.errorText = errorMsg;
    $scope.creatingnote = false;
  }
}